.root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
